import api from "../services/api-gateway";

export async function consultarTecnicosExternosPorEmail(): Promise<any> {
	return api.get("/s610-gateway-servico/v1/credenciadas/tecnicos-externos/validar-acesso");
}

export async function getAnexosAlocacaoExterna(idAS: number): Promise<any> {
	return api.get(`/s610-gateway-servico/v1/credenciadas/autorizacao-servicos/${idAS}/anexos`);
}

export async function getAnexoAlocacaoExterna(idAnexo: number): Promise<any> {
	return api.get(`/s610-gateway-servico/v1/credenciadas/autorizacao-servicos/anexos/${idAnexo}`);
}

export async function consultarVersaoCredenciada(): Promise<any> {
	return api.get("/s610-gateway-servico/v1/credenciadas/versao-credenciada");
}